import React from 'react';
import { IconProps } from '../types';

export const AIDevelopmentIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
            d="M12.5965 12.6355H5.34514C3.74258 12.6355 2.44458 13.9335 2.44458 15.5361V27.1383C2.44458 28.7409 3.74258 30.0389 5.34514 30.0389H25.6491C27.2516 30.0389 28.5496 28.7409 28.5496 27.1383V15.5361"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path d="M6.79541 8.2846V5.38403" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
        <path
            d="M6.7955 5.38408C7.59646 5.38408 8.24578 4.73477 8.24578 3.9338C8.24578 3.13283 7.59646 2.48352 6.7955 2.48352C5.99453 2.48352 5.34521 3.13283 5.34521 3.9338C5.34521 4.73477 5.99453 5.38408 6.7955 5.38408Z"
            fill={color}
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M10.421 24.7212C11.6225 24.7212 12.5964 23.7472 12.5964 22.5458C12.5964 21.3443 11.6225 20.3704 10.421 20.3704C9.21957 20.3704 8.24561 21.3443 8.24561 22.5458C8.24561 23.7472 9.21957 24.7212 10.421 24.7212Z"
            fill={color}
        />
        <path
            d="M20.5731 24.7212C21.7746 24.7212 22.7485 23.7472 22.7485 22.5458C22.7485 21.3443 21.7746 20.3704 20.5731 20.3704C19.3717 20.3704 18.3977 21.3443 18.3977 22.5458C18.3977 23.7472 19.3717 24.7212 20.5731 24.7212Z"
            fill={color}
        />
        <path
            d="M15.4971 8.76801C19.5013 8.76801 22.7485 5.52083 22.7485 1.5166C22.7485 5.52083 25.9957 8.76801 29.9999 8.76801"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path
            d="M15.4971 8.76794C19.5013 8.76794 22.7485 12.0151 22.7485 16.0193C22.7485 12.0151 25.9957 8.76794 29.9999 8.76794"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
        />
    </svg>
);
